import type { Condition } from '../../hooks/useProductData';
import { convertToShortNumber, getMaxAmount, getMinRateString, getRateRangeString } from '../humanization';

export const getMortgageConditions = (item): Condition[] => {
  const conditions = [];

  const { minRate, maxRate, minInitialAmount, maxInitialAmount, minPsk, maxPsk } = item;

  const initialAmountValue = getMinRateString(
    {
      from: minInitialAmount,
      to: maxInitialAmount,
    },
    true,
    'Без взноса',
  );
  conditions.push({ value: initialAmountValue, description: 'Перв. взнос' });

  const rateValue = getMinRateString({ from: minRate, to: maxRate }, true);
  rateValue && conditions.push({ value: rateValue, description: 'Ставка' });

  if (minPsk >= 0 && maxPsk >= 0) {
    const pskValue = getRateRangeString({ from: minPsk, to: maxPsk, fractionDigits: 3 }, '');
    conditions.push({ value: pskValue, description: 'Полная ст-ть кредита', wide: true });
  }

  let sumValue = null;
  const { calcMaxSum, calcMinSum } = item;

  if (calcMaxSum <= 0) {
    sumValue = `от ${convertToShortNumber(calcMinSum)} ₽`;
  } else {
    sumValue = getMaxAmount(
      {
        from: calcMinSum,
        to: calcMaxSum,
      },
      {
        postfix: ' ₽',
        prefix: true,
        isConvert: true,
      },
      'Любая',
    );
  }

  sumValue && conditions.push({ value: sumValue, description: 'Сумма' });

  return conditions;
};
